import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const AdminVideoStudio = lazy(() => import("@/pages/admin/AdminVideoStudio"));

export const Route = createFileRoute("/admin/video-studio")({
  component: AdminVideoStudio,
});
